import React from 'react';
import { FormattedMessage as Trans } from 'react-intl';

import { useNewsletter } from '../hooks/useNewsletter';

import FormFieldText from './FormFieldText';
import Tooltip from './Tooltip';
import Button from './Button';

export default function FormNewsletter() {
  const { newsletterData, setNewsletterData, subscribeToNewsletter } =
    useNewsletter();
  const { isValidEmail, isLoading, email, isSubscribed } = newsletterData;

  const showSubscribeButton = isValidEmail && !isLoading;

  return (
    <>
      <div className="form-newsletter">
        <p className="heading-two">
          <Trans
            id={
              isSubscribed
                ? 'formNewsletterSuccessMessage'
                : 'buttonLabelSubscribe'
            }
          />
        </p>
        {!isSubscribed && (
          <div className="form-newsletter__container">
            <FormFieldText
              onChange={(e) =>
                setNewsletterData((prevState) => ({
                  ...prevState,
                  email: e.target.value
                }))
              }
              value={email}
              id={`form-newsletter-email-input`}
              name="email"
              label="placeholderEmail"
              type="email"
              required={false}
              additionalClassNames="--text-white"
            />
            {showSubscribeButton && (
              <div className="form-newsletter__button">
                <Tooltip label="formNewsletterTooltipDescription">
                  <Button
                    onClick={subscribeToNewsletter}
                    button={{
                      tabIndex: -1,
                      version: 'secondary-text',
                      additionalClassNames: '--x-small',
                      label: <Trans id="buttonLabelSubscribe" />,
                      icon: 'MdArrowForward',
                      iconPosition: 'right'
                    }}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
